import type { CatalogRide, RideId } from '@runkr/config/catalog'
import { RideCard } from './RideCard'
import styles from './rides.module.css'

/**
 * The Rides tab (PHASE3 T3.11): the catalogue's six rides, the equipped one framed. All are
 * owned while rides are free (no shop yet); T3.9's prices lock the others.
 */
export function RideGrid({
  rides,
  equipped,
  owns,
  onPick,
}: {
  rides: readonly CatalogRide[]
  equipped: RideId
  owns: (id: RideId) => boolean
  onPick: (id: RideId) => void
}) {
  return (
    <div class={styles.grid} role="group" aria-label="Rides">
      {rides.map((r) => (
        <RideCard
          key={r.id}
          ride={r}
          equipped={r.id === equipped}
          owned={owns(r.id)}
          onPick={onPick}
        />
      ))}
    </div>
  )
}
